/*****************************************************************************
 * UmanIT - Fait apparaître la liste des réseaux sociaux
 *****************************************************************************/

const button = document.querySelector("[data-trigger='social-network']");
const buttonClose = document.querySelector("[data-trigger='close-social-network']");
const socialNetworkContainer = document.querySelector("[data-target='social-network']");

button.addEventListener("click", function() {
  button.classList.toggle("active");
  socialNetworkContainer.classList.toggle("active");
});

buttonClose.addEventListener("click", closePopin);

/**
 * Cache la popin de partage sur les réseaux sociaux
 *
 * return {void}
 */
function closePopin() {
  button.classList.remove("active");
  socialNetworkContainer.classList.remove("active");
}
